import { Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import { Outlet } from "react-router-dom";
import ExportImagePopup from "../../components/common/ExportImagePopup/ExportImagePopup";
import AnonymousUsageLimitPopup from "../../components/Popups/AnonymousUsageLimitPopup/AnonymousUsageLimitPopup";
import OrgInfoPopup from "../../components/Popups/OrgInfoPopup/OrgInfoPopup";
import PricingFlow from "../../components/Popups/Pricing/PricingFlow";
import SubscriptionLinkGeneratorPopup from "../../components/Popups/SubscriptionLinkGeneratorPopup/SubscriptionLinkGeneratorPopup";
import { useAppStore } from "../../hooks/useStores";
import LabsHeader from "./Header/LabsHeader";
import styles from "./LabsLayout.module.scss";

const LabsLayout = () => {
	const { uiStore, authStore, anonymousUsageStore } = useAppStore();
	return (
		<Box className={styles.labsLayout}>
			<LabsHeader />
			<Outlet />
			{uiStore.ExportImagePopup && <ExportImagePopup open={uiStore.ExportImagePopup} />}
			{uiStore.SubscriptionLinkGeneratorPopup && authStore.isLoggedIn && authStore.user?.isSuperAdmin() && (
				<SubscriptionLinkGeneratorPopup />
			)}
			{uiStore.OrgInfoPopup && authStore.isLoggedIn && authStore.user?.isSuperAdmin() && <OrgInfoPopup />}
			<PricingFlow />
			<AnonymousUsageLimitPopup
				open={anonymousUsageStore.limitReachedFeature !== null}
				onClose={() => anonymousUsageStore.setLimitReachedFeature(null)}
			/>
		</Box>
	);
};

export default observer(LabsLayout);
